import { getAuth, signOut as authSignOut } from "firebase/auth";
import { notification } from "../utils-functions/notification";

export async function signOut() {
    try {
        // Sign out from Firebase
        const auth = getAuth();
        await authSignOut(auth);

        // Clear local storage "user" object
        localStorage.removeItem("user");
        localStorage.removeItem("authUser");
        notification("Signed out", "You have signed out successfully", "info");
    } catch (err) {
        console.log(err.message);
    }
}
